import * as React from 'react';
import { Link } from 'react-router-dom';
import { styled } from 'styled-components';
import { hasValue } from '../../lib/lib';
import {
	brandingColourLightV2,
	labelRedColour,
	tabletPortraitMinWidth,
	whiteBackground,
	whiteColour
} from '../../appComponents/cssConstants';
import { MessageTypes } from '../../core/enums';

const ActionItem = ({ action, onClick, messageType }: Props) => {
	const { label, internalLink, emailHref, callback = false } = action;
	const isErrorType = messageType === MessageTypes.Error;

	if (!hasValue(internalLink) && !hasValue(emailHref) && !callback)
		throw new Error(`Invalid modal action item: ${action.label}`);

	return (
		<ActionLink $isErrorType={isErrorType}>
			{internalLink && (
				<Link to={internalLink} onClick={onClick}>
					{label}
				</Link>
			)}
			{emailHref && (
				<a href={emailHref} onClick={onClick}>
					{label}
				</a>
			)}
			{callback && (
				<TextButton
					type="button"
					onClick={async () => {
						await callback();
						onClick();
					}}
				>
					{label}
				</TextButton>
			)}
		</ActionLink>
	);
};

export default ActionItem;

interface Props {
	action: ModalAction;
	onClick: () => void;
	messageType: MessageTypes;
}

export interface ModalAction {
	label: string;
	internalLink?: string;
	emailHref?: string;
	callback?: () => Promise<void> | void;
}

const ActionLink = styled.li<{ $isErrorType: boolean }>`
	margin-bottom: 12px;
	width: 274px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		width: 60%;
	}

	&& * {
		display: block;
		border-radius: 22px;
		text-decoration: none;
		padding: 10px 24px 10px 24px;
		font-size: 14px;
		font-weight: 500;
		line-height: 24px;
		letter-spacing: 0.1px;
		width: 100%;

		@media (min-width: ${tabletPortraitMinWidth}) {
			font-size: 16px;
		}
	}

	&:first-child * {
		color: ${whiteColour};
		background: ${(props) => (props.$isErrorType ? labelRedColour : props.theme.primaryBackground)};
	}

	&:nth-child(2) * {
		color: ${(props) => props.theme.linkTextColor};
		background: ${whiteBackground};
		border: 1px solid ${brandingColourLightV2};
	}
`;

const TextButton = styled.button`
	border: none;
	background: none;
	padding: 0;
`;
